import "./style.scss";

// Smooth scroll for anchor links
document.addEventListener("DOMContentLoaded", function () {
	// Handle clicks on anchor links
	document.addEventListener("click", function (e) {
		const link = e.target.closest('a[href^="#"]');

		if (!link || link.getAttribute("href") === "#") {
			return;
		}

		const targetId = link.getAttribute("href").substring(1);
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			e.preventDefault();
			targetElement.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		}

		if (window.matchMedia("(max-width: 992px)").matches) {
			const responsiveContainer = link.closest(
				".wp-block-navigation__responsive-container.is-menu-open",
			);

			if (responsiveContainer) {
				const closeButton = responsiveContainer.querySelector(
					".wp-block-navigation__responsive-container-close",
				);

				if (closeButton) {
					closeButton.click();
				} else {
					responsiveContainer.classList.remove("is-menu-open");
					document.documentElement.classList.remove("has-modal-open");
				}
			}
		}
	});

	// Handle hash in URL on page load
	if (window.location.hash) {
		const targetId = window.location.hash.substring(1);
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			setTimeout(() => {
				targetElement.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
			}, 100);
		}
	}

	const teamMembers = Array.from(document.querySelectorAll(".team-item"));
	let activeMember = null;

	function getTeamName(member) {
		const teamClasses = Array.from(member.classList).filter(
			(cls) =>
				cls.startsWith("team-") &&
				!cls.includes("arrow") &&
				!cls.includes("bio") &&
				cls !== "team-item",
		);
		return teamClasses.length > 0 ? teamClasses[0].replace("team-", "") : null;
	}

	function findBioForMember(member) {
		const teamName = getTeamName(member);
		if (!teamName) return null;

		let bio = document.querySelector(`.team-${teamName}-bio`);

		if (!bio) {
			bio = document.querySelector(`.team-${teamName}-bio.team-bio`);
		}

		if (!bio) {
			const allBios = document.querySelectorAll(".team-bio");
			bio = Array.from(allBios).find((b) =>
				b.classList.contains(`team-${teamName}-bio`),
			);
		}

		if (!bio) {
			const teamItemsContainer = document.querySelector(".team-items");
			if (teamItemsContainer) {
				let nextSibling = teamItemsContainer.nextElementSibling;
				while (nextSibling) {
					if (nextSibling.classList.contains("wp-block-group")) {
						bio = nextSibling.querySelector(`.team-${teamName}-bio`);
						if (bio) break;
					}
					nextSibling = nextSibling.nextElementSibling;
				}
			}
		}

		if (!bio) {
			const groupContainers = document.querySelectorAll(".wp-block-group");
			for (const container of groupContainers) {
				const foundBio = container.querySelector(`.team-${teamName}-bio`);
				if (foundBio) {
					bio = foundBio;
					break;
				}
			}
		}

		return bio;
	}

	// Helper function to show member's arrow and bio
	function showMemberContent(member) {
		const arrow = member.querySelector('[class*="team-arrow"]');
		const bio = findBioForMember(member);

		if (arrow) arrow.style.opacity = "1";

		if (bio) {
			bio.style.setProperty("display", "block", "important");
			bio.style.setProperty("visibility", "visible", "important");
			bio.style.setProperty("opacity", "1", "important");

			const parentGroup = bio.closest(".wp-block-group");
			if (parentGroup) {
				parentGroup.style.setProperty("display", "block", "important");
				parentGroup.style.setProperty("visibility", "visible", "important");
				parentGroup.style.setProperty("opacity", "1", "important");
			}
		}
	}

	// Helper function to hide member's arrow and bio
	function hideMemberContent(member) {
		const arrow = member.querySelector('[class*="team-arrow"]');
		const bio = findBioForMember(member);
		if (arrow) arrow.style.opacity = "0";
		if (bio) {
			bio.style.setProperty("display", "none", "important");
			const parentGroup = bio.closest(".wp-block-group");
			if (parentGroup) {
				parentGroup.style.setProperty("display", "none", "important");
			}
		}
	}

	// Helper function to set a member as active
	function setActiveMember(member) {
		teamMembers.forEach((m) => {
			m.classList.remove("active");
			hideMemberContent(m);
			m.style.removeProperty("display");
		});

		activeMember = member;
		member.classList.add("active");
		member.style.setProperty("display", "block", "important");
		showMemberContent(member);
		updateNavigationButtons();
	}

	// Helper function to get current active index
	function getActiveIndex() {
		if (!activeMember) return -1;
		return teamMembers.indexOf(activeMember);
	}

	function navigateToPrevious() {
		const currentIndex = getActiveIndex();
		if (currentIndex > 0) {
			setActiveMember(teamMembers[currentIndex - 1]);
		} else {
			setActiveMember(teamMembers[teamMembers.length - 1]);
		}
	}

	function navigateToNext() {
		const currentIndex = getActiveIndex();
		if (currentIndex < teamMembers.length - 1) {
			setActiveMember(teamMembers[currentIndex + 1]);
		} else {
			setActiveMember(teamMembers[0]);
		}
	}

	const teamItemsContainer = document.querySelector(".team-items");

	function createMobileNavigation() {
		if (!teamItemsContainer || teamMembers.length <= 1) return;

		const navContainer = document.createElement("div");
		navContainer.className = "team-mobile-nav";

		const arrowSVG = `<svg width="39" height="37" viewBox="0 0 39 37" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M24.0467 36.1585L38.7716 0.000199782L-0.00043823 14.403L17.5277 20.32L24.0467 36.1585Z" fill="currentColor"></path>
		</svg>`;

		const prevButton = document.createElement("button");
		prevButton.className = "team-nav-prev";
		prevButton.setAttribute("aria-label", "Previous team member");
		prevButton.innerHTML = arrowSVG;
		prevButton.addEventListener("click", navigateToPrevious);

		const nextButton = document.createElement("button");
		nextButton.className = "team-nav-next";
		nextButton.setAttribute("aria-label", "Next team member");
		nextButton.innerHTML = arrowSVG;
		nextButton.addEventListener("click", navigateToNext);

		navContainer.appendChild(prevButton);
		navContainer.appendChild(nextButton);

		teamItemsContainer.appendChild(navContainer);

		window.teamNavPrev = prevButton;
		window.teamNavNext = nextButton;
	}

	function updateNavigationButtons() {
		if (!window.teamNavPrev || !window.teamNavNext) return;
		window.teamNavPrev.disabled = false;
		window.teamNavNext.disabled = false;
	}

	let firstActiveMember = null;

	if (teamItemsContainer) {
		const firstTeamItem = teamItemsContainer.querySelector(".team-item");
		if (firstTeamItem) {
			firstActiveMember = firstTeamItem;
		}
	}

	if (!firstActiveMember && teamMembers.length > 0) {
		firstActiveMember = teamMembers[0];
	}

	if (firstActiveMember) {
		setActiveMember(firstActiveMember);
	}

	createMobileNavigation();

	teamMembers.forEach((member) => {
		const arrow = member.querySelector('[class*="team-arrow"]');
		if (!arrow) return;

		member.addEventListener("mouseenter", () => {
			setActiveMember(member);
		});
	});

	// Parallax effect for cover blocks
	const coverBlocks = document.querySelectorAll(".wp-block-cover");

	coverBlocks.forEach((cover) => {
		const bgImage = cover.querySelector(".wp-block-cover__image-background");
		if (!bgImage) return;

		let isInView = false;

		// Intersection Observer to track when element is in viewport
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					isInView = entry.isIntersecting;
				});
			},
			{ threshold: 0 },
		);

		observer.observe(cover);

		// Parallax scroll effect
		function updateParallax() {
			if (!isInView) return;

			const rect = cover.getBoundingClientRect();
			const scrollPercent =
				(window.innerHeight - rect.top) / (window.innerHeight + rect.height);

			// Image moves from bottom (entering viewport) to top (exiting viewport)
			const containerHeight = rect.height;
			const translateY = (scrollPercent - 0.5) * containerHeight * 1.2;
			bgImage.style.transform = `translateY(${translateY}px)`;
		}

		window.addEventListener("scroll", updateParallax, { passive: true });
		updateParallax(); // Initial position
	});

	// Mouse parallax effect for head-section
	const headSection = document.querySelector(".head-section");

	if (headSection) {
		const defaultX = 50; // 50%
		const defaultY = -100; // -100px
		const parallaxStrengthX = 20; // Horizontal movement
		const parallaxStrengthY = 60; // Vertical movement (increased for pixels)

		document.addEventListener("mousemove", (e) => {
			// Calculate mouse position as percentage from center (-0.5 to 0.5)
			const mouseX = e.clientX / window.innerWidth - 0.5;
			const mouseY = e.clientY / window.innerHeight - 0.5;

			// Calculate new background position
			const newX = defaultX + mouseX * parallaxStrengthX;
			const newY = defaultY + mouseY * parallaxStrengthY;

			headSection.style.backgroundPosition = `${newX}% ${newY}px`;
		});
	}
});
